import React,{ Component } from 'react';
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Select, Button,message,Divider} from 'antd';
import {dbFields} from '../../model/role/column';
import { route } from '../../routes/routes';
import { EditRole ,GetRoleById} from "../../model/role/requests";
import storage from '../../utils/storage';
import { configs } from '../../config/config';

export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
const Option = Select.Option;
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};


export default class RoleEdit extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state={
            role:{},
            menu:""
        }
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    componentDidMount(){
        let roleId = this.props.match.params.id;
        GetRoleById({id:roleId}).then(res=>{
            let role = {}
            if(res.data.code === 200) {
                 role = res.data.data
                this.setState({
                    role:role
                })
                this.formRef.current.setFieldsValue(role);
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerSubmit = (e) => {
        let name = this.formRef.current.getFieldValue(dbFields.name.key);
        let roleId = this.props.match.params.id;
        let role = this.state.role
        let menu = (this.state.menu === "" ) ? role.menu :this.state.menu
        EditRole({name:name,id:roleId,menu:menu}).then(res=>{
            if(res.data.code === 200){
                message.success(configs.http.responseMsg.created)
                setTimeout(()=>{
                    this.props.history.push(route.role.index)
                },1000)
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })
        
        
    }

    handlerMenuPermsChange = record =>{
        this.setState({
            menu:record
        })
    }

    render(){
        const {role} = this.state
        return (
            <>
                  <BreadcrumbCustomer   first='Role' second='Edit' />
              <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        name: role.name,
                        menu:role.menu
                    }}
                >
                        <Form.Item
                            name= {dbFields.name.key}
                            label={dbFields.name.title}
                        >
                            <Input />
                        </Form.Item>
     
                        <Form.Item label="Menu Permission" name="menu" >
                        <Select 
                            onChange={this.handlerMenuPermsChange}
                        >
        
                            { configs.menuPermsList.map((items) => {
                                 return (<Option  attr={items.id} key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>

                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                            type="primary" 
                            style={{background: "#851dd6",color:"white" }}
                            onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    
                </Form>    
            </>
        )
    }
}